import { MatPaginatorIntl } from '@angular/material';

export class TraducaoPaginator extends MatPaginatorIntl {
  constructor() {
    super();
    this.nextPageLabel = ' Próxima página';
    this.previousPageLabel = ' Página anterior';
    this.itemsPerPageLabel = ' Registros por página';
    this.lastPageLabel = ' Última página';
    this.firstPageLabel = ' Primeira página';
  }
}